module.exports = __webpack_public_path__ + "img/foto condell.d569ab03.jpg";